import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

/**
 * Returns whether the current user has the 'admin' role.
 * Backed by the security-definer `has_role()` function — never reads
 * a profile column, so it cannot be spoofed by client-side tampering.
 */
export const useIsAdmin = () => {
  return useQuery({
    queryKey: ["is-admin"],
    queryFn: async (): Promise<boolean> => {
      const { data: { user } } = await supabase.auth.getUser();
      if (!user) return false;

      const { data, error } = await supabase.rpc("has_role", {
        _user_id: user.id,
        _role: "admin",
      });

      if (error) {
        // Fail closed: no role match => not admin
        return false;
      }
      return data === true;
    },
    staleTime: 1000 * 60 * 5,
  });
};
